/* Home family photographs: enable only with the early home performance flag. */
(() => {
  'use strict';

  function init() {
    if (!document.documentElement.classList.contains('basic-home-performance')) return;
    const cards = [...document.querySelectorAll('.families .family-card')];
    if (!cards.length) return;

    const reveal = (card) => card.classList.add('family-image-ready');
    const revealAll = () => cards.forEach(reveal);
    if (!('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    try {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '200px', threshold: 0 });
      cards.forEach((card) => {
        observer.observe(card);
        card.addEventListener('focus', () => {
          reveal(card);
          observer.unobserve(card);
        }, { once: true });
      });
    } catch (_) {
      revealAll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
